import Swiper from "swiper/bundle";
import "./_embed-video-slider.scss";

document.addEventListener("DOMContentLoaded", () => {
  const SliderCards = document.querySelectorAll(".video-embed-slider");
  SliderCards.forEach((slider) => {
    new Swiper(slider, {
      loop: false,
      spaceBetween: 16,
      slidesPerView: 1,
      keyboard: {
        enabled: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
        dynamicBullets: false,
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
        },
        992: {
          slidesPerView: 3,
        },
      },
    });
  });
});
